import { useContext, useEffect, useState } from 'react';
import styles from '../../styles/Loyalty.module.css';
import { CircularProgress } from '@mui/material';
import { LoyaltyRewardType, LoyaltyReward } from '../../pages/api/loyalty/rewards';
import { ColorContext } from './Contexts';

interface RewardProps {
    reward: LoyaltyReward;
    onUnlock: (reward: LoyaltyReward, data?: any) => Promise<void>;
}

function GeneralReward({ reward, onUnlock }: RewardProps) {
    const color = useContext(ColorContext);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!reward.unlocked) {
            onUnlock(reward).catch(() => setError(true));
        }
    }, [reward]);

    if (!reward.data) {
        if (error) {
            return <div className={styles.error}>Oh no! Something went wrong while uploading your files.</div>;
        }
        return <CircularProgress color='inherit' size={24} />
    }

    return <>
        <div className={styles.rewardDetailTitle}>
            {reward.instructions}
        </div>
        {reward.data.code && <div className={styles.rewardCode}>{reward.data.code}</div>}
        <div style={{ paddingTop: 16 }}>
            {
                reward.data.links?.map((link, i) =>
                    <a key={i} className={styles.button} style={{ marginBottom: 8, color, backgroundColor: color + '2b' }} href={link.url} target="_blank" rel="noreferrer">{link.text}</a>
                )
            }
        </div>
    </>
}

function ManualReward({ reward, onUnlock }: RewardProps) {
    const color = useContext(ColorContext);
    const [submission, setSubmission] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    async function onSubmit() {
        setLoading(true);
        onUnlock(reward, { submission })
            .catch(() => setError(true))
            .finally(() => setLoading(false));
    }

    if (!reward.unlocked) {
        return <>
            <div className={styles.rewardDetailTitle}>
                {reward.instructions}
            </div>
            <textarea value={submission} rows={4} onChange={(e) => setSubmission(e.currentTarget.value)} />
            <button className={styles.button} style={{ width: '100%', color, backgroundColor: color + '2b' }} onClick={onSubmit} disabled={loading || !submission}>{loading ? "Submitting..." : "Submit"}</button>
            {error && <div className={styles.error}>Oh no! Something went wrong while uploading your files.</div>}
        </>
    }

    if (!reward.data) {
        return <CircularProgress color='inherit' size={24} />
    }

    return <div className={styles.rewardDetailTitle}>
        {reward.data.text}
    </div>
}

export default function Reward(props: RewardProps) {
    if (props.reward.type === LoyaltyRewardType.GENERAL) {
        return <GeneralReward {...props} />
    } else {
        return <ManualReward {...props} />
    }
}